import { createSelector } from 'reselect';
import { TemplatesState } from './types';
import { CREATIVES_PENDING_STATUSES } from '../creatives/creatives.constants';

export const getTemplates = (state: any): TemplatesState => state.templates;
const getCurrentTemplates = (state: any) => getTemplates(state).templates;
export const getTemplatesActionProgress = createSelector(
    getTemplates,
    (
        templates,
    ): {
        deleteInProgress: TemplatesState['deleteInProgress'];
        renamingInProgress: TemplatesState['renamingInProgress'];
    } => ({
        deleteInProgress: templates.deleteInProgress,
        renamingInProgress: templates.renamingInProgress,
    }),
);

export const getPendingTemplates = createSelector(getCurrentTemplates, (templates) =>
    templates
        .filter((template) => CREATIVES_PENDING_STATUSES.includes(template.thumbnailStatus))
        .map((template) => template.id),
);

export const getSelectedTemplateIds = (state: any) => getTemplates(state).checked;

const getCategories = (state): any[] => state.categories.categories;
export const templatesSelector = (state): any[] => state.templates.templates;
export const singleTemplateSelector = (state): any => state.templates.template;
export const selectedTemplateIdSelector = (state): any => state.templates.selectedTemplateId;
export const categoriesTemplatesSelector = createSelector(getCategories, (categories) =>
    categories.reduce((acc: any[], category) => {
        if (category.templates) {
            acc.push(...category.templates);
        }

        return acc;
    }, []),
);

export const selectedTemplateSelector = createSelector(
    templatesSelector,
    categoriesTemplatesSelector,
    selectedTemplateIdSelector,
    singleTemplateSelector,
    (templates, categoriesTemplates, selectedTemplateId, queriedTemplate) => {
        const listTemplates =
            templates.find((template) => template.id === selectedTemplateId) ||
            categoriesTemplates.find((template) => template.id === selectedTemplateId);

        if (!listTemplates) {
            return queriedTemplate;
        }

        return listTemplates;
    },
);
